export default {
  ua: {
    zrm: {
      ZUID: 'dimension1', // Encoded user token: <anonymousId>/X1-ZU<encodedUserToken>, use getServerSideEncodedGuidZuid helper
      STATE: 'dimension3',
      CITY: 'dimension5',
      ZIP: 'dimension6',
      ITC: 'dimension51', // ITC param
      EVENT_CONTENT: 'dimension54', // Event page context
      FULL_REFERRING_URL: 'dimension69', // Full referring URL
      LISTING_ID: 'dimension82',
      PAGE_CATEGORY: 'dimension136', // rentals
      RENTAL_MANAGER_USER_SUMMARY: 'dimension137', // MFH:false|ALC:0|TLC:8_<plain user token>
      AB_TEST_NAME: 'dimension156',
      AB_TEST_VALUE: 'dimension157',
    },
    hp: {
      USER_TOKEN: 'dimension31', // Plain user token
      RENTAL_MANAGER_USER_SUMMARY: 'dimension33', // MFH:false|ALC:0|TLC:8_<plain user token>
    },
    multibrand: {
      USER_TOKEN: 'dimension1', // Plain user token
      RENTAL_MANAGER_USER_SUMMARY: 'dimension2', // MFH:false|ALC:0|TLC:8_<plain user token>
      IS_MOBILE_APP: 'dimension3', // Used to track if web app is loaded in a mobile web view
    },
  },
  gtm: {
    USER_TOKEN: 'dimension1', // Plain user token
    RENTAL_MANAGER_USER_SUMMARY: 'dimension2', // MFH:false|ALC:0|TLC:8_<plain user token>
    PROPERTY_STATE: 'dimension3', // property state (CA)

    /**
     * Note that while this mobile app dimension is read as dimension 4 in
     * the GTM datalayer, it is then passed as custom dimension 3 to the
     * multibrand UA account. Similarly, the SOH dimension is read as 5 in
     * GTM but passed to UA as 4. This pattern will likely hold for all
     * new dimensions added in the future.
     */
    IS_MOBILE_APP: 'dimension4', // Used to track if web app is loaded in a mobile web view
    IS_SOH: 'dimension5', // usd to track if user is in the sense of home experience
  },
};
